export default {
  survey_answers: {
    Survey_PriceVisit_Very_Correct: 'Très correct',
    Survey_PriceVisit_Correct: 'Correct',
    Survey_PriceVisit_High: 'Élevé',
    Survey_WithWhom_Couple: 'en couple',
    Survey_WithWhom_Family: 'en famille',
    Survey_WithWhom_Friends: 'avec des ami(e)s',
    Survey_WithWhom_Other: 'autre',
    Survey_WithWhom_Group: 'en groupe organisé',
    Survey_WithWhom_Solo: 'en solo',
    Survey_FirstVisit_NoCameOnce: 'Non, je suis déjà venu une fois',
    Survey_FirstVisit_NoCameSeveralTimes: "Non, je suis déjà venu plus d'une fois",
    Survey_WithWhom_FamilyUnder18: 'En famille, dont enfant(s) de moins de 18 ans',
    Survey_WithWhom_FamilyNoUnder18: 'En famille, uniquement de plus de 18 ans',
    Yes: 'Oui',
    No: 'Non',
    Survey_Maybe: 'Peut-être',
    Survey_HistoPadUserFriendly_YesIntuitive: "Tout à fait, c'est intuitif !",
    Survey_HistoPadUserFriendly_YesOk: 'Oui, ça va',
    Survey_Origin_ForeignCountry: 'Pays étranger',
    Survey_Origin_France: 'France',
    Survey_Reside_Answer_HautesPyrenees: 'Hautes-Pyrénées',
    Survey_Reside_Answer_HauteGaronne: 'Hautes-Garonne',
    Survey_Reside_Answer_PyreneesAtlantique: 'Pyrénées-Atlantique',
    Survey_Reside_Answer_Gers: 'Gers',
    Survey_Reside_Answer_Other: 'Autre',
    Survey_ResideHautesPyrenees_Answer_Campan: 'Vallée de Campan (La Mongie, Bagnères de Bigorre)',
    Survey_ResideHautesPyrenees_Answer_Gavarnie: 'Vallée de Gavarnie (Barèges, Luz, Gavarnie)',
    Survey_ResideHautesPyrenees_Answer_Gaves: 'Vallée des Gaves (Cauterets, Argelès, Val d’Azun)',
    Survey_ResideHautesPyrenees_Answer_AureLouron: 'Vallée d’Aure et du Louron (St Lary, Arreau)',
    Survey_ResideHautesPyrenees_Answer_Lourdes: 'Lourdes',
    Survey_ResideHautesPyrenees_Answer_Other: 'Ailleurs dans les Hautes-Pyrénées',
    Survey_ResideHauteGaronne_Answer_Luchon: 'Luchon',
    Survey_ResideHauteGaronne_Answer_Other: 'Ailleurs en Haute-Garonne',
    Survey_Income_Answer_LessThan1500: '– de 1500€',
    Survey_Income_Answer_1500To3000: '1500 à 3000€',
    Survey_Income_Answer_3000To4500: '3000 à 4500',
    Survey_Income_Answer_4500To6000: '4500 à 6000',
    Survey_Income_Answer_MoreThan6000: '6000€ et +',
    Survey_Income_Answer_NoAnswer: 'Ne souhaite pas répondre',
    Survey_Planetarium_Answer_Yes: 'Oui',
    Survey_Planetarium_Answer_No: 'Non',
    Survey_SeanceCoupole_Answer_Yes: 'Oui',
    Survey_SeanceCoupole_Answer_No: 'Non',
    Survey_HearAboutSite_WordMouth: 'Bouche à oreille',
    Survey_HearAboutSite_Report: 'Reportage (TV/Radio/Journal…)',
    Survey_HearAboutSite_Internet: 'Internet',
    Survey_HearAboutSite_Flyer: 'Dépliant',
    Survey_HearAboutSite_Other: 'Autre',
    Survey_HearAboutExhibit_WordOfMouth: 'Bouche à oreille',
    Survey_HearAboutExhibit_Digital: 'Numérique (téléphone portable/en ligne)',
    Survey_HearAboutExhibit_Print: 'Presse (journal/magazine)',
    Survey_HearAboutExhibit_Radio: 'Radio',
    Survey_HearAboutExhibit_Television: 'Télévision',
    Survey_HearAboutExhibit_Other: 'Autre',
    Survey_HearAboutExhibit_Advertisement: 'Publicité',
    Survey_HearAboutExhibit_Report: 'Rapport',
    Survey_Gender_Male: 'Homme',
    Survey_Gender_Female: 'Femme',
    Television: 'Television',
    Radio: 'Radio',
    Survey_RentingPrice_JustRight: 'Juste',
    Survey_RentingPrice_TooLow: 'Trop faible',
    Survey_RentingPrice_TooHigh: 'Trop élevé',
    Others: 'Autres réponses',
    Survey_VisitPrice_VeryCorrect: 'Très correct',
    Survey_VisitPrice_Correct: 'Correct',
    Survey_VisitPrice_High: 'Élevé',
    Survey_WithWhom_GroupTwentyMore: 'en groupe (20 pers. et +)',
    Survey_Coming_WordMouth: 'Bouche à oreille',
    Survey_Coming_TravelGuide: 'Guides touristiques',
    Survey_Coming_CastleWebsite: 'Site internet du château',
    Survey_Coming_CastleFlyer: 'Brochure du château',
    Survey_Coming_CastleActivity: 'Activités proposées sur site',
    Survey_Coming_TouristOffice: 'Office du tourisme',
    Survey_Coming_AdvertDisplay: 'Affichage publicitaire',
    Survey_Coming_Media: 'Presse (TV, Radio, articles)',
    Survey_Transportation_Car: 'en voiture',
    Survey_Transportation_Bus: 'en autocar',
    Survey_Transportation_NavetteRemi: 'en bus-navette château Rémi',
    Survey_Transportation_Bicycle: 'en vélo',
    Survey_VisitPrice_Correct_Meissen: 'Correct',
    Survey_VisitPrice_High_Meissen: 'Elevé',
    Survey_HearAboutSite_WordMouth_Meissen: 'Bouche à oreille',
    Survey_HearAboutSite_Internet_Meissen1: 'Site internet schloesserland-sachsen.de',
    Survey_HearAboutSite_Internet_Meissen2: 'Site internet albrechtsburg-meissen.de',
    Survey_HearAboutSite_Internet_Moritzburg: 'Site internet schloss-moritzburg.de',
    Survey_OtherOffers_Event_Moritzburg: 'Événements au château de Moritzburg',
    Survey_OtherOffers_Moritzburg:
      "Visite d'autres installations de loisirs dans la région, par exemple le mémorial de Käthe Kollwitz ou le Fasanenschloss",
    Survey_HasImprovedVisit_YesGreat: 'Oui, beaucoup !',
    YesAbsolutely: 'Oui, absolument',
    Survey_HasImprovedVisit_YesOk: 'Oui, sans plus',
    Survey_VisitPrice_Low: 'Trop bas',
    Survey_HearAboutSite_Internet_OtherWebsites: 'Autres sites internet',
    Survey_HearAboutSite_Instagram: 'Instagram',
    Survey_HearAboutSite_Facebook: 'Facebook',
    Survey_HearAboutSite_Magazines: 'Presse écrite',
    Survey_HearAboutSite_AdvertisementMeissen: 'Affiches publicitaires',
    Survey_HearAboutSite_Flyer2: 'Dépliants, brochures',
    Survey_HearAboutSite_TouristInformationsoffice: 'Office de tourisme',
    Survey_HearAboutSite_Hotel: 'Hébergement',
    Survey_HearAboutSite_Advertisement: 'Publicité (Affichage/Radio/Réduction…)',
    Survey_HearAboutSite_FlyerAdvertisement: 'Dépliant et publicité (affichage, flyer)',
    Survey_Age_Category1: 'Moins de 14 ans',
    Survey_Age_Category2: '14-19 ans',
    Survey_Age_Category3: '20-29 ans',
    Survey_Age_Category4: '30-39 ans',
    Survey_Age_Category5: '40-49 ans',
    Survey_Age_Category6: '50-59 ans',
    Survey_Age_Category7: '60-69 ans',
    Survey_Age_Category8: 'Plus de 70 ans',
    Survey_Age_Category9: '14-18 ans',
    Survey_Age_Category10: '19-30 ans',
    Survey_Age_Category11: '31-45 ans',
    Survey_Age_Category12: '46-60 ans',
    Survey_Age_Category13: '60-70 ans',
    Survey_Age_Category14: '71-80 ans',
    Survey_Age_Category15: '81 ans et +',
    Survey_Age_Under18: 'Moins de 18 ans',
    '18–25': '18-25 ans',
    '26–41': '26–41 ans',
    '42–57': '42–57 ans',
    '58–67': '58–67 ans',
    '68–76': '68–76 ans',
    '77+': '77 ans et plus',
    PreferNotToAnswer: 'Je préfère ne pas répondre',
    Survey_HasImprovedVisit_NoImprovement: 'Non, pas du tout',
    Survey_WillRecommend_Sure: 'Bien sûr!',
    Survey_WillRecommend_MostlySure: 'Certainement',
    Survey_WillRecommend_DontKnow: 'Je ne sais pas',
    Survey_WillRecommend_MaybeNot: 'Plutôt pas',
    Survey_WillRecommend_NotAtAll: 'En aucun cas',
    Survey_OtherOffers_Gastronomy: 'Gastronomie',
    Survey_OtherOffers_GuidedTour: 'Visite guidée',
    Survey_OtherOffers_Hiking: 'Randonnée dans les environs',
    Survey_OtherOffers_RentANightAround: 'Hébergement dans les environs',
    Survey_OtherOffers_Shopping: 'Shopping',
    Survey_OtherOffers_Others: 'Autres',
    Survey_VisitPrice_VeryHappy: 'Très satisfait',
    Survey_VisitPrice_Happy: 'Satisfait',
    Survey_VisitPrice_Good: 'Ça va',
    Survey_VisitPrice_NotMuchHappy: 'Plutôt pas satisfait',
    Survey_VisitPrice_NotHappyAtAll: 'Pas satisfait du tout',
    HistoricalCharacter: 'Personnage historique',
    HistoricalMonument: 'Monument historique, patrimoine mondial',
    HistoricalEvent: 'Événement historique',
    Survey_ContinueOnline_YesNewXP: 'Oui, s’il y a de nouvelles expériences',
    Survey_ContinueOnline_YesWithoutXP: 'Oui, même sans nouvelles expériences',
    Survey_HearAboutSite_Medias: 'Médias',
    Survey_HearAboutSite_SocialMedia: 'Réseaux sociaux',
    Survey_HearAboutSite_Display: 'Affichage',
    Survey_HearAboutSite_Press: 'Presse',
    Survey_HearAboutSite_ResearchEngine: 'Moteur de recherche',
    'Survey_HearAboutSite_Website_notredame-sachsen': 'Site internet notredame-dresden.de',
    Survey_WithWhom_SoloSeul: 'seul',
    Survey_DresdenOffers_AudioGuide: "L'audioguide Schlösserland pour le Grand Jardin",
    Survey_DresdenOffers_ParkRailway: 'Promenade avec le petit train du parc au Grand Jardin',
    Survey_DresdenOffers_Gastronomie: 'Restauration dans le Grand Jardin de Dresde',
    Survey_DresdenOffers_HygieneMuseum: "Visite du musée allemand de l'hygiène de Dresde",
    Survey_DresdenOffers_Zoo: 'Visite du zoo de Dresde',
    Survey_DresdenOffers_Festung: 'Visite de la Festung Xperience',
    Survey_DresdenOffers_Zwinger: 'Visite du Zwinger Xperience',
    Survey_DresdenOffers_Overnight: 'Hébergement dans les environs',
    YesLovedIt: "Oui, j'ai adoré",
  },
  survey_questions: {
    Survey_Rating_WelcomeAccessibility: 'Accueil et disponibilité du personnel',
    Survey_Rating_PracticalInformations: 'Informations pratiques',
    Survey_Rating_WaitingTime: "Temps d'attente",
    Survey_Rating_ComfortCleanliness: 'Confort et propreté',
    Survey_Choice_VisitPrice: 'Comment évaluez-vous le prix de la visite ?',
    Survey_HistoPadUserFriendly_Question: "L'HistoPad est-il facile à utiliser ?",
    Survey_OpenAnswer_WhatCanWeChange: 'Si non, que pouvons-nous améliorer ?',
    Survey_Age_Question: 'Quel âge avez-vous ?',
    Survey_Origin_Question: "D'où venez vous ?",
    Survey_Origin_Pays: "D'où venez-vous (pays étranger) ?",
    Survey_Origin_Departement: "D'où venez-vous (département) ?",
    Survey_Origin_France: "D'où venez-vous (France)?",
    Survey_FirstVisit_Question: 'Est-ce votre première visite ?',
    Survey_FirstVisitHere: 'Est-ce votre première visite en ce lieu ?',
    Survey_WithWhom_Question: 'Vous êtes venus...',
    Survey_Rating_Signalitique: 'Signalétique et information dans le site',
    Survey_Rating_CafeChateau: '« Café » du château',
    Survey_Rating_PropreteMonument: 'Propreté et entretien du monument',
    Survey_Rating_PropreteSanitaires: 'Propreté des sanitaires',
    Survey_Rating_VisiteChapelle_Chateau: 'Visite de la chapelle et du château',
    Survey_Rating_VisiteJardins: 'Visite des jardins',
    Survey_Rating_NotesEnfants: 'Qu’ont pensé vos enfants de leur visite au château ?',
    Survey_Reside_Question: 'Où résidez-vous pendant votre séjour ?',
    Survey_ResideHautesPyrenees_Question:
      'Où résidez-vous dans les Hautes-Pyrénées pendant votre séjour ?',
    Survey_ResideHauteGaronne_Question: 'Où résidez-vous en Haute-Garonne pendant votre séjour ?',
    Survey_Income_Question: 'Quel est le revenu mensuel net de votre foyer ?',
    Survey_Recommend_Question: 'Recommanderez-vous la visite du Pic du Midi ?',
    Survey_ExperienceRating_Question_CableCar: 'Le voyage en téléphérique',
    Survey_ExperienceRating_Question_Panorama: 'Le panorama',
    Survey_ExperienceRating_Question_Ponton: 'Le ponton',
    Survey_ExperienceRating_Question_Animations: 'Les animations',
    Survey_ExperienceRating_Question_EspaceExperiences: "L'espace expériences",
    Survey_ExperienceRating_Title: 'Avez-vous aimé votre expérience au Pic du Midi ?',
    Survey_Planetarium_Question: 'Avez-vous assisté à une séance de Planétarium ?',
    Survey_PlanetariumRating_Question: 'Le Planétarium',
    Survey_PlanetariumRating_Title: 'Avez-vous aimé cette séance de Planétarium ?',
    Survey_SeanceCoupole_Question: 'Avez-vous assisté à une séance de Coupole ?',
    Survey_SeanceCoupoleRating_Question: 'La Coupole',
    Survey_SeanceCoupoleRating_Title: 'Avez-vous aimé cette séance de Coupole ?',
    Survey_HearAboutSite_Question: 'Comment avez-vous entendu parler du musée ?',
    Survey_HearAboutSite_Us: 'Comment avez-vous entendu parler de nous ?',
    Survey_Origin_ZIPCode: 'Quel est votre code postal ?',
    Survey_HearAboutExhibit_Question: 'Comment avez-vous entendu parler de cette exposition ?',
    Survey_HearAboutExhibitInputField_Question:
      'Comment avez-vous entendu parler de cette exposition ?',
    Survey_VisitExhibitPrimaryReason_Question:
      "Cette exposition était-elle la principale raison de votre visite aujourd'hui ?",
    Survey_Gender_Question: 'Etes vous un homme ou une femme ?',
    Survey_GroupSize_Question: 'Combien y avait-il de visiteurs dans votre groupe ?',
    Survey_RentingPrice_Question: "Que pensez-vous du prix de location de l'HistoPad ?",
    Survey_HistopadEaseOfUse_Question: "Facilité d'utilisation de la tablette",
    Survey_HistopadContentQuality_Question: 'Qualité du contenu de la tablette',
    Survey_HistopadOverallExperience_Question: 'Expérience globale de la tablette',
    Survey_ExhibitNavigation_Question: 'Facilité de déplacement',
    Survey_ExhibitPanelContent_Question: 'Qualité du contenu des panneaux',
    Survey_ExhibitOverallExperience_Question: "Expérience globale de l'exposition",
    Survey_Rating_Boarding: 'Embarquement',
    Survey_Rating_Itinerary: 'Itinéraire proposé',
    Survey_Rating_AudioContent: 'Commentaire audio',
    Survey_Rating_InteractiveXP: 'Expériences interactives',
    Survey_VisitPrice_Question: 'Comment évaluez-vous le prix de la visite ?',
    Survey_FirstVisit_Question_Paris: 'Est-ce votre première visite à Paris ?',
    Survey_Rating_Welcome: 'Accueil',
    Survey_Rating_TipStart: 'Conseils pour la prise en main',
    Survey_Rating_ComfortVisit: 'Confort de visite',
    Survey_Rating_Orientation: 'Orientation dans le château',
    Survey_VisitPrice_Question_CastleHistoPad:
      'Comment évaluez-vous le prix de la visite ? (château + HistoPad)',
    Survey_Decide_Question: "Qu'est-ce qui va vous décider à venir?",
    Survey_Coming_Question: 'Vous êtes venu…',
    Survey_Origin_GermanLand: 'Land',
    Survey_VisitPrice_Question_Meissen: 'Comment évaluez-vous le prix de la visite ?',
    Survey_HasImprovedVisit_Question: "L'Histopad a-t-il amélioré votre visite ?",
    Survey_WillRecommend: "Recommanderiez-vous votre visite à d'autres ?",
    Survey_SaySomethingMore: 'Avez-vous une remarque supplémentaire ?',
    Survey_Rating_Signage: 'Signaletique',
    Survey_Bookstore: 'Librairie-boutique (conseil et choix)',
    Survey_HearAboutSiteInputField_Question: 'Comment avez-vous entendu parler du musée ?',
    Survey_RestaurantSaline: 'Restaurant "La table des jardins"',
    Survey_Age_Question_Categories: "À quelle tranche d'âge appartenez-vous ?",
    Survey_Rating_StaffAmability: "De l'amabilité du personnel",
    Survey_Rating_StaffCompetence: 'De la compétence du personnel',
    Survey_OtherOffers_Question:
      'Quelles autres offres utilisez-vous ? (plusieurs réponses possibles)',
    Survey_VisitPrice_QuestionVariant:
      'Quel est votre degré de satisfaction à propos du rapport qualité-prix ?',
    Survey_HearAboutSite_UsSeveralChoices:
      'Comment avez-vous entendu parler de nous ? (plusieurs réponses possibles)',
    Survey_HistoPadUserFriendly_WhatCanWeChange: 'Si non, que pouvons-nous améliorer ?',
    Survey_OtherSites_Question: "Souhaitez-vous voir d'autres sites équipés de l'Histopad ?",
    Survey_OtherExhibits_Question:
      "Souhaitez-vous voir d'autres expositions comme celle-ci dans le musée ?",
    Survey_ExperienceWas_Ludic: 'Avez-vous trouvé l’expérience de visite ludique',
    Survey_ExperienceWas_Pedagogic: 'Avez-vous trouvé l’expérience de visite pédagogique',
    Survey_ExperienceWas_Immersive: 'Avez-vous trouvé l’expérience de visite immersive',
    Survey_WillRecommend_AugmentedExhibits:
      'Recommanderiez-vous cette Exposition Augmentée à votre entourage ?',
    Survey_OtherAugmentedExhibits_question:
      'Aimeriez-vous visiter une autre Exposition Augmentée avec l’HistoPad ?',
    Survey_IfYesWhichSubject: 'Si oui, sur quel sujet ?',
    Survey_WouldYouPay_AugmentedExhibits:
      'Seriez-vous prêt à payer pour cette Exposition Augmentée ?',
    Survey_IfYesHowMuch: 'Si oui, combien ?',
    Survey_ContinueOnline_Question: 'Aimeriez-vous prolonger l’expérience chez vous sur le web ?',
    Survey_HistoPadFirstTime: 'Est-ce la première fois que vous utilisez un HistoPad ?',
    Survey_HearAboutSite_AugmentedExhibit:
      'Comment avez-vous entendu parler de l’Exposition Augmentée ?',
    Survey_OtherAugmentedExhibits_OrPlace_question:
      "Aimeriez-vous visiter une autre exposition ou un autre site avec l'HistoPad ?",
    Survey_GrossenGarten_Dresden:
      'Est-ce votre première visite au Palais du Grand Jardin de Dresde ?',
    Survey_OtherOffers_Question_long:
      "Quelles sont les offres que vous avez déjà utilisé aujourd'hui ou que vous allez encore utiliser ?",
    Survey_Impression_captivating: 'Passionnant',
    Survey_Rating_StaffWelcomeAvailability: "De l'accueil et disponibilité du personnel",
    Survey_VisitPrice_Ratio: 'Rapport qualité prix',
    Survey_Rating_SignageInsideCity: 'Signalétique intérieur et urbaine',
    Survey_Bookstore_AdviceChoice: 'Boutique (conseil et choix)',
    Survey_Rating_VisitContent: 'Contenu de la visite',
    Survey_Rating_OpeningHoursMHAB: 'Horaires du MHAB',
    Survey_HearAboutSite_MHAB: 'Comment avez-vous entendu parler du MHAB ?',
    Survey_WillRecommend_MHAB: 'Recommanderiez-vous la visite du MHAB ?',
    Survey_Net_Promoter_Score: 'Taux de recommandation net',
  },
}
